import { Directive, Input, OnDestroy } from '@angular/core';
import { Subject, Subscription, from } from 'rxjs';
import { throttleTime, exhaustMap } from 'rxjs/operators';
import { CommonService } from '../services/commonService';
import { IVinValidationContext, VehicleWeightClassCode } from '../modal/IVinValidationContext';
import { vehicleDetails } from '../modal/DAO';

@Directive({
  selector: '[VinSpecificationsChecker]',
  standalone: true,
  host: {
    '(blur)': 'onAction()',
    '(keydown.enter)': 'onAction()'
  }
})

export class VinSpecificationsCheckerDirective implements OnDestroy {
  @Input() currentVehicle: vehicleDetails;
  @Input() referenceNumber: string;
  @Input() vehicleSizeOptions: any[];

  private readonly actionSubject = new Subject<void>();
  private readonly actionSubscription: Subscription;

  constructor(private commonService: CommonService) {
    this.actionSubscription = this.actionSubject.pipe(
      throttleTime(300), exhaustMap(() => from(this.handleAction()))
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.actionSubscription?.unsubscribe();
  }

  async onAction(): Promise<void> {
    this.actionSubject.next();
  }

  private async handleAction(): Promise<void> {
    if (!this.currentVehicle || !this.referenceNumber) return;

    if (!!this.currentVehicle.vehicleVin?.status) return;

    const vin: string = this.currentVehicle.vehicleVin?.answer?.trim() ?? '';
    if (!vin || vin.length < 5 || vin.length > 17) return;

    this.currentVehicle.vehicleYear.answer = '';
    this.currentVehicle.vehicleMake.answer = '';
    this.currentVehicle.vehicleModel.answer = '';
    if (this.currentVehicle.vehicleVin.group.startsWith('VEH')) {
      this.currentVehicle.vehicleSize.answer = '';
    }

    const payload = {
      urlData: [this.referenceNumber],
      payloadData: [
        {
          vin: vin,
          group: this.currentVehicle.vehicleVin.group
        }
      ]
    };

    try { 
      const response = await this.commonService.post('vehicle', 'validateVins', payload, false).toPromise();
      response.forEach((context: IVinValidationContext) => {
        this.currentVehicle.vehicleVin.status = context.checkedStatus ?? "";
        this.currentVehicle.vehicleYear.answer = context.year && Number(context.year) > 1900 ? context.year : '';
        this.currentVehicle.vehicleMake.answer = context.make ?? '';
        this.currentVehicle.vehicleModel.answer = context.model ?? '';

        if (context.group.startsWith('VEH')) {
          this.currentVehicle.vehicleSize.answer = this.vehicleSizeOptions?.find(o => o.code === VehicleWeightClassCode(context))?.value ?? '';
        }
      });
    } catch(error) {
      console.error('Error while validating VINs:', error);
    }
  }
}